import { http } from "../config.api.js"
// 材料报审
// 定时器
export const apitemp = () => { return http.get("job/createProjectQuarterEvalDataTask").then(res => res.data); };

export const listProjectMaterials = (pageInfo, params) => { return http.get("/projectMaterialsPost/listProjectMaterials/" + pageInfo, { urlParams: params }).then(res => res.data); };

// export const listTestOrg = (pageInfo, params) => { return http.get("/projectMaterialsPost/detectedMechanisms/" + pageInfo, { urlParams: params }).then(res => res.data); };
export const listTestOrg = (pageInfo, params) => { return http.get("/projectMaterialsPost/getDetectedMechanismsNew/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const uploadDetectedReport = params => {
    return http.post("/projectMaterialsPost/uploadDetectedReport", params, { headers: {'Content-Type': 'multipart/form-data'} }).then(res => res.data);
};

export const materialProjectList = (pageInfo, params) => { return http.get("/projectMaterialsPost/materialProjectList/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const materialPostRecord = (pageInfo, params) => { return http.get("/projectMaterialsPost/materialPostRecord/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const getProjectMaterialDetail = params => { return http.get("/projectMaterialsPost/projectMaterialDetail", { urlParams: params }).then(res => res.data); };

export const getReports = (pageInfo, params) => { return http.get("/projectMaterialsPost/reports/" + pageInfo, { urlParams: params }).then(res => res.data); };
export const getReportsNew = (pageInfo, params) => { return http.get("/projectMaterialsPost/getReportsNew/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const getMainPostUnit = params => { return http.get("/projectMaterialsPost/mainPostUnit", { urlParams: params }).then(res => res.data); };

export const deleteProjectMaterial = params => { return http.delete("/projectMaterialsPost/delete", { urlParams: params }).then(res => res.data); };

export const revokeProjectMaterial = params => { return http.post("/projectMaterialsPost/revoke", params).then(res => res.data); };

export const saveProjectMaterial = params => { return http.post("/projectMaterialsPost/save", params).then(res => res.data); };

export const sign = params => { return http.post("/projectMaterialsPost/sign", params).then(res => res.data); };

export const review = params => { return http.post("/projectMaterialsPost/review", params).then(res => res.data); };

export const submitProjectMaterial = params => { return http.post("/projectMaterialsPost/submitProjectMaterial", params).then(res => res.data); };

export const signByConstructionProjDepartment = params => { return http.post("/projectMaterialsPost/signByConstructionProjDepartment", params).then(res => res.data); };

export const getMaterialAuditRecord = params => { return http.get("/auditRecord/materialAuditRecords", { urlParams: params }).then(res => res.data); };

export const projectMaterialsReports = (pageInfo, params) => { return http.get("/projectMaterialsList/projectMaterialsReports/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const getUnitInfo = (pageInfo, params) => { return http.get("/unitInfo/unitInfos/" + pageInfo, { urlParams: params }).then(res => res.data); };



// WEBPACK FOOTER //
// ./src/api/project/api_projectMaterials.js